module.exports = __webpack_public_path__ + "static/media/ecolabel.221ab8ad.png";